import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'letrus-ui';
import useGoBackOrHome from 'containers/SimplifiedFeedback/useGoBackOrHome';
import styles from './SimplifiedFeedbackHeader.module.scss';

// TODO: real copy from Mari Parro not received yet — placeholder confirmed in the Lovable
// prototype (/devolutiva), pending pedagogical validation.
const PAGE_TITLE = 'Olha só o seu texto!';
const PAGE_SUBTITLE =
  'Lemos tudo o que você escreveu. Veja o que a gente achou.';

function SimplifiedFeedbackHeader(): JSX.Element {
  const goBackOrHome = useGoBackOrHome();

  return (
    <header data-focusid="header">
      <nav className={styles.nav}>
        {/* variant="secondary" (not "tertiary") — found by Raissa in review, 2026-09-24: same
        DS issue as the closing block (SimplifiedFeedbackClosing), applied here too. */}
        <Button
          variant="secondary"
          onClick={goBackOrHome}
          aria-label="Voltar para a home"
        >
          <FontAwesomeIcon icon={['fas', 'house']} />
          Voltar para a home
        </Button>
      </nav>

      <div className={styles.pageTitle}>
        <h1>{PAGE_TITLE}</h1>
        <p>{PAGE_SUBTITLE}</p>
      </div>
    </header>
  );
}

export default SimplifiedFeedbackHeader;
